import { ReactElement } from 'react'

export interface IFaqProps {
  id: number
  title: string
  body: ReactElement
}

export const landingFaq: IFaqProps[] = [
  {
    id: 1,
    title: 'آیا افراد حقیقی هم می‌توانند فروشنده شوند یا فقط شرکت‌ها؟',
    body: (
      <div>
        <p>
          بله، افراد حقیقی با داشتن جواز کسب می‌توانند در آپولون به‌عنوان فروشنده
          ثبت‌نام کنند و محصولات خود را عرضه کنند.
        </p>
      </div>
    )
  },
  {
    id: 2,
    title: 'چه مدارکی برای ثبت‌نام لازم است؟',
    body: (
      <div>
        <p>
          برای افراد حقیقی معمولاً مدارک شناسایی، جواز کسب، مدارک مالیاتی و اطلاعات
          حساب بانکی لازم است. برای فروشگاه‌های حقوقی، مدارک ثبت شرکت، شناسه ملی،
          اساسنامه و مدارک هویتی افراد مسئول نیز مورد نیاز خواهد بود.
        </p>
      </div>
    )
  },
  {
    id: 3,
    title: 'زمان بررسی درخواست ثبت‌نام چقدر است؟',
    body: (
      <div>
        <p>
          معمولاً بررسی مدارک و اطلاعات شما بین ۷ تا ۱۴ روز کاری انجام می‌شود و پس
          از تأیید، وضعیت ثبت‌نام در پنل شما به‌روزرسانی خواهد شد.
        </p>
      </div>
    )
  },
  {
    id: 4,
    title: 'نرخ کمیسیون فروش در آپولون چگونه محاسبه می‌شود؟',
    body: (
      <div>
        <p>
          میزان کمیسیون بسته به نوع محصول، دسته‌بندی و شرایط فروش شما متفاوت است و
          قبل از شروع فعالیت در پنل فروشنده به‌صورت شفاف اعلام می‌شود.
        </p>
      </div>
    )
  },
  {
    id: 5,
    title: 'هزینه ارسال و بسته‌بندی بر عهده چه کسی است؟',
    body: (
      <div>
        <p>
          بسته به شرایط همکاری، ارسال و بسته‌بندی ممکن است توسط فروشنده یا آپولون
          انجام شود. این موضوع در زمان ثبت سفارش و با توجه به سیاست‌های فروشگاه
          مشخص می‌شود.
        </p>
      </div>
    )
  },
  {
    id: 6,
    title: 'پشتیبانی فروشندگان به چه شکل انجام می‌شود؟',
    body: (
      <div>
        <p>
          فروشندگان می‌توانند سوالات فنی، فروش و سفارش‌ها را از طریق تیم پشتیبانی
          آپولون و بخش پنل فروشنده با ما در میان بگذارند و راهنمایی‌های لازم را
          دریافت کنند.
        </p>
      </div>
    )
  },
  {
    id: 7,
    title: 'چگونه درآمد فروش محصولات به حساب فروشنده واریز می‌شود؟',
    body: (
      <div>
        <p>
          پس از تسویه حساب و محاسبه درآمد خالص، مبلغ به حساب بانکی ثبت‌شده در پنل
          فروشنده واریز می‌شود. زمان و فرایند دقیق تسویه در قرارداد همکاری ذکر شده
          است.
        </p>
      </div>
    )
  }
]
